export class ExternalLinksConstants {

  static readonly SURVIVORLINK_INFORMATION_SHEET: string = 'https://cdn.buttercms.com/0hBpAkTTrmRoHvxekELg';
  static readonly SURVIVORLINK_LOGO_URL: string = "https://cdn.buttercms.com/resize=height:300/a8Dt6gdXQEeNqEsx5Azm"

}
